import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'unique'
})
export class UniquePipe implements PipeTransform {
  transform(value: any[], key: string): any[] {
    if (!Array.isArray(value)) {
      return value;
    }

    const uniqueValues = new Set();

    return value.filter(item => {
      const keyValue = item[key];
      if (!uniqueValues.has(keyValue)) {
        uniqueValues.add(keyValue);
        return true;
      }
      return false;
    });
  }
}
